<template>
    <vs-row>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">event</span>
            <label>Date of Birth</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex justify-between items-center p-1">
            <flat-pickr v-if="editBox"
            v-model="teacherPersonalDetails.bio.dob"
          />
            <p v-else>{{teacherPersonalDetails.bio.dob?teacherPersonalDetails.bio.dob:'Not Available'}}</p>
            <span class="material-icons-outlined small_icon cursor-pointer" @click="editBox = true" v-if="!editBox">border_color</span>
            <span class="material-icons-outlined small_icon cursor-pointer" @click="updateBio" v-if="editBox">save</span>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">flag</span>
            <label>Nationality</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex items-center p-1">
            <vs-input v-if="editBox" v-model="teacherPersonalDetails.bio.nationality" />
             <p v-if="!editBox">{{teacherPersonalDetails.bio.nationality?teacherPersonalDetails.bio.nationality:'Not Available'}}</p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">language</span>
            <label>Website</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex items-center p-1">
            <vs-input v-if="editBox" v-model="teacherPersonalDetails.bio.website" />
            <p v-else>{{teacherPersonalDetails.bio.website?teacherPersonalDetails.bio.website:'Not Available'}}</p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex p-1">
            <span style="margin-top: 4px;" class="material-icons-outlined small_icon">person</span>
            <label>Biography</label>
        </vs-col>        
        <vs-col vs-lg="8" vs-sm="12" class="flex items-end p-1">
          <vs-textarea v-if="editBox" v-model="teacherPersonalDetails.bio.biodata" />
            <p style="max-height: 100px; overflow: auto" class="vertical_scrollbar">{{teacherPersonalDetails.bio.biodata?teacherPersonalDetails.bio.biodata:'Not Available'}}</p>
            <!-- <a v-if="teacherPersonalDetails.bio.biodata" style="white-space: nowrap; cursor: pointer;" class="inline-block" @click="showMore = !showMore">
                <span v-if="showMore">Read More</span>
                <span v-else>Show Less</span>
            </a> -->
        </vs-col> 
    </vs-row>  
</template>

<script>
import { TeacherUpdate } from '@/api/teacher'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    flatPickr
  },
  props: {
    teacherPersonalDetails:{
      default:{}
    },
    havePermission:{
      default: false
    },
    updateTeacher:{
      default:()=>{}
    }
  },
  data () {
    return {
      showMore: true,
      editBox: false
    }
  },
  methods: {
    async updateBio () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            bio:this.teacherPersonalDetails.bio
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          JSON.parse(localStorage.getItem('userInfo')).id,
          customer_id
        )
        this.editBox = false
        this.setAfterUpdate(data)
        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
        return data
      } catch (e) {
        this.showSuccessMessage('Warning', e.data.message, 'warning')
      }
      
    }
  }
}
</script>